import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=46091a76&"
import script from "./particulars.vue?vue&type=script&lang=js&"
export * from "./particulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports